<template>
  <tr>
    <td>{{ label }}</td>
    <td>
      <div class="form-group">
        <label class="form-switch">
          <input type="checkbox" v-model="value">
          <i class="form-icon"></i>
        </label>
      </div>
    </td>
    <td class="text-right" style="width:50px">
      <button class="btn btn-sm btn-icon btn-action"
              :class="value ? 'btn-info' : 'btn-neutral'"
              :disabled="!value"
              @click="openMessageModal(item)">
        <fa-icon :icon="['fal', 'pencil']"></fa-icon>
      </button>
    </td>
  </tr>
</template>

<script>
import { capitalize } from '@/filters/capitalize';
import settings from '@/data/settings';

export default {
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      value: this.item.value,
      saving: false,
    };
  },
  computed: {
    label() {
      return this.item.key in settings
        ? settings[this.item.key]
        : (
          this.item.key.split('.')
            .map(v => v.replace(/[A-Z]/g, $ => ` ${$.toUpperCase()}`))
            .join(' ')
            .trim()
            .split(' ')
            .map(v => capitalize(v))
            .join(' ')
        );
    },
  },
  watch: {
    value() {
      this.update();
    },
  },
  methods: {
    update() {
      this.saving = true;
      this.$http
        .put('/customer-settings', {
          key: this.item.key,
          value: this.value,
        })
        .catch(() => {})
        .then(() => {
          this.saving = false;
        });
    },
    openMessageModal(item) {
      this.$emit('openMessageModal', item);
    },
  },
};
</script>
